import React from 'react';
import { Grid } from '@mui/material';
import { helix } from 'ldrs';
import { themeObject } from 'lib';

helix.register();

export const HelixLoaderComponent = (): React.JSX.Element => {
    return (
        <Grid position={'absolute'} top={'50%'} left={'50%'}>
            <l-helix
                color={themeObject.palette.tertiary.purple[500]}
                size={60}
            />
        </Grid>
    );
};
